import i18n from 'utils/i18n'
import type { AdminRetailPublicPagesFilterName } from 'utils/filters/admin'
import type { TableFiltersConfig } from 'components/Common/Table/Layout/Page/_methods/types'
import {
  filterTypes,
  CHECKBOX_LIST,
  DATE_INTERVAL,
  RADIO_LIST,
  SEARCH_USERS,
  ADMIN_FILTERS_KEY,
  ADMIN_FILTERS_TITLE,
  ADMIN_FILTERS_NAME,
} from 'utils/consts'

export const getAdministrationRetailPublicPagesFiltersCollection = () => [
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.eshopCountryFilter),
    filterName:
      ADMIN_FILTERS_NAME.eshopCountryFilter satisfies AdminRetailPublicPagesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.eshopCountryFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.parsingFilter),
    filterName:
      ADMIN_FILTERS_NAME.parsingFilter satisfies AdminRetailPublicPagesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.parsingFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.eshopFilter),
    filterName:
      ADMIN_FILTERS_NAME.merchantFilter satisfies AdminRetailPublicPagesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.merchantFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.canonicalLinkFilter),
    filterName:
      ADMIN_FILTERS_NAME.canonicalLinkFilter satisfies AdminRetailPublicPagesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.canonicalLinkFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.isMerchantSetFilter),
    filterName:
      ADMIN_FILTERS_NAME.isMerchantSetFilter satisfies AdminRetailPublicPagesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.isMerchantSetFilter,
  },

  {
    type: filterTypes[DATE_INTERVAL],
    title: i18n.t(ADMIN_FILTERS_TITLE.lastUpdateFilter),
    filterName:
      ADMIN_FILTERS_NAME.updatedAtFilter satisfies AdminRetailPublicPagesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.updatedAtFilter,
  },
  {
    type: filterTypes[DATE_INTERVAL],
    title: i18n.t(ADMIN_FILTERS_TITLE.createdAtFilter),
    filterName: ADMIN_FILTERS_NAME.createdAtFilter,
    apiFilterName: ADMIN_FILTERS_KEY.createdAtFilter,
  },
  {
    type: filterTypes[SEARCH_USERS],
    title: i18n.t(ADMIN_FILTERS_TITLE.creationUserFilter),
    filterName:
      ADMIN_FILTERS_NAME.updateUserUsernameFilter satisfies AdminRetailPublicPagesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.updateUserUsernameFilter,
  },
]

export const adminRetailPublicPagesFiltersConfig: TableFiltersConfig = {
  getFiltersCollection: getAdministrationRetailPublicPagesFiltersCollection,
  pathToStore: [],
  filtersDataPath: ['admin', 'tradeOffers', 'tradeOffersFilters'],
  showResultsTextKey: 'filters.button.apply',
}
